module.exports = __webpack_public_path__ + "static/media/politicas_header.6f99ff9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/politicas_header.png
// module id = 446
// module chunks = 1